import { render, staticRenderFns } from "./previewPopups.vue?vue&type=template&id=1e2dfade"
import script from "./previewPopups.vue?vue&type=script&lang=ts"
export * from "./previewPopups.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_762a4ceba611ab1d58a92326b3604e6f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports